import { useAuthStore } from '@/v2/store/shared/auth-store';
import { Timestamp } from 'firebase/firestore';

export function getTenantCollectionPath(collectionName) {
	const authStore = useAuthStore();
	const tenantId = authStore.tenantId;
	return `tenants/${tenantId}/ecommerce/default/${collectionName}`;
}

export function getDateValue(value) {
	if (!value) return null;
	if (value instanceof Date) return value;
	if (value instanceof Timestamp) return value.toDate();
	return new Date(value);
}
